import { FormControl, FormField as ShadcnFormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form"
import { InputWithBadges } from "@/components/ui/input-with-badges"
import { useTranslation } from "react-i18next"
import { Path, type FieldValues, type UseFormReturn } from "react-hook-form"

interface MezzaTagsFieldProps<T extends FieldValues> {
  form: UseFormReturn<T>
  name: keyof T
  label: string
  placeholder?: string
  className?: string
  disabled?: boolean
  clearButtonText?: string
  badgeVariant?: "default" | "secondary" | "destructive" | "outline"
}

export function MezzaTagsField<T extends FieldValues>({
  form,
  name,
  label,
  placeholder,
  className,
  disabled,
  clearButtonText,
  badgeVariant,
}: MezzaTagsFieldProps<T>) {
  const { t } = useTranslation()
  
  return (
    <ShadcnFormField
      control={form.control}
      name={name as Path<T>}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t(label)}</FormLabel>
          <FormControl>
            <InputWithBadges
              value={field.value || []}
              placeholder={placeholder ? t(placeholder) : undefined}
              className={className}
              onChange={field.onChange}
              onBlur={field.onBlur}
              disabled={disabled}
              badgeVariant={badgeVariant}
              clearButtonText={clearButtonText ? t(clearButtonText) : t('common.clear')}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
} 